<template>
  <div class="col-12 relative grey-bg full-height flex flex-column">
    <template v-if="routeMatchesComponent() || !route.meta.breadcrumb">
      <!-- TODO Improves -->
      <CategoryHeader :title="route.meta.title" :icon="route.meta.icon" />
    </template>
    <Transition>
      <Modal v-if="showModal">
        <template #body>
          <div class="flex items-center container-cart justify-center full-height">
            <div>
              <!-- SUCCESS -->
              <div v-if="successModal" class="mb5 col-12 success-checkmark">
                <div class="check-icon">
                  <span class="icon-line greener-bg line-tip"></span>
                  <span class="icon-line greener-bg line-long"></span>
                  <div class="icon-circle"></div>
                  <div class="icon-fix"></div>
                </div>
              </div>
              <div v-else class="mb5 center col-12">
                <i style="font-size: 88px;" class="icon red line-height-2 icon-not-check-icon"></i>
              </div>
              <div class="h2 center" :class="successModal ? 'green': 'red'">
                <h2 class="h2n">{{ modalMessage }}</h2>
              </div>
              <div class="mt1 center my2">
                <Button text="Fermer" class="col-12" btn-color="red" :action="closeModal" />
              </div>
            </div>
          </div>
        </template>
      </Modal>
    </Transition>
    <div v-if="loading" class="relative full-height flex items-center justify-center pb5">
      <div class="center">
        <div class="list-loader-blue"></div>
      </div>
    </div>

    <router-view v-else class="p3" />
  </div>
</template>

<script>
import { getCurrentInstance, onBeforeMount, ref, provide, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import qrcode from 'qrcode';
import Modal from '@/components/blocks/Modal';
import Button from '@/components/elements/Button';

import { routeIsCurrentComponent, isInImpersonateModeNotification } from '@/mixins/utils';

import CategoryHeader from '@/components/common/CategoryHeader';
import { getEbillets, cancelReservation } from '@/mixins/requests';

export default {
  components: { CategoryHeader, Modal, Button },
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const workspace = computed(() => store.state.siteInfo.workspace || []);
    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());
    const showModal = ref(false);
    const successModal = ref(true);
    const modalMessage = ref('');

    const closeModal = () => { showModal.value = false; };

    const loading = computed(() => store.state.loadingContent);

    const ebillets = ref([]);
    const status_code = ref(0);

    const drawQrCodes = async billets => {
      if (billets) {
        const options = { margin: 1, scale: 6 };
        let optCanvas = null;
        billets.map(async billet => {
          const canvas = await qrcode.toString(billet.qrcode, options);
          billet.qrcodeSvg = canvas;

          (billet.options || []).map(async opt => {
            if (opt.qrcode) {
              optCanvas = await qrcode.toString(opt.qrcode, options);
              opt.qrcodeSvg = optCanvas;
            }
          });
        });
      }
    };

    onBeforeMount(async () => {
      store.commit('setLoadingContent', true);

      const response = await getEbillets().then(async r => {
        const billets = r.eBillets;
        await drawQrCodes(billets);
        return { billets, status_code: r.status_code };
      }).catch(err => ({ billets: [], status_code: err.status_code })).finally(() => {
        store.commit('setLoadingContent', false);
      });
      ebillets.value = response.billets;
      status_code.value = response.status_code;
    });

    const cancel = async s => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoadingContent', true);

      const data = {
        workspace: workspace.value,
        sessionCode: s.code,
        numeroContrat: s.numeroContrat,
        user: s.participant_uuid,
        sessionName: s.type,
        startTimestamp: s.startTimestamp,
        endTimestamp: s.endTimestamp
      };

      modalMessage.value = 'Une erreur s’est produite lors de l’annulation de votre réservation';
      successModal.value = false;

      await cancelReservation(data).then(res => {
        if (res.success) {
          modalMessage.value = 'Annulation réussie';
          successModal.value = true;
        }
      }).catch(() => []).finally(async () => {
        const response = await getEbillets().then(async r => {
          const billets = r.eBillets;
          await drawQrCodes(billets);
          return { billets, status_code: r.status_code };
        }).catch(err => ({ billets: [], status_code: err.status_code })).finally(() => {
          showModal.value = true;
          store.commit('setLoadingContent', false);
        });
        ebillets.value = response.billets;
        status_code.value = response.status_code;
      });
    };

    provide('ebillets', ebillets);
    provide('ebilletsStatus', status_code);

    provide('cancel', cancel);
    provide('showModal', showModal);

    return {
      ebillets,
      router,
      route,
      loading,
      showModal,
      modalMessage,
      closeModal,
      successModal,
      routeMatchesComponent
    };
  }
};
</script>
